import { STYLES_RATING } from '../constants';
import type { RatingStyle } from '../types';

export const letterDescriptionRating = (rating: number): RatingStyle => {
  if (rating < 5) return STYLES_RATING.bad;
  if (rating < 8) return STYLES_RATING.goodEnough;
  if (rating < 9) return STYLES_RATING.good;
  return STYLES_RATING.perfect;
};
